export const ATX = 0.1; // Agravamento em tx
export const ACC = 0.5; // Agravamento em cc

/* Fator que e combinacao de acc e atx */
export const FATOR_COMBINACAO = ACC / ATX;

const defaultDocument = {
  comissao_percentual_passo5: 0,
  comissao_reais_passo5: 0,
  taxa_passo5: 0,
  premio_passo5: 0,
  premio_minimo_passo5: 160
};

export default {
  data() {
    return {
      // These looks to be constant.
      atx: ATX, //Agravamento em tx,
      acc: ACC, //Agravamento em cc,

      /* Variveis de cálculos */
      Cr: 0, //Comissão
      P: 0, // Prêmio
      Tx: 0, // Taxa
      Cc: 0, // % comissão
      So: 20, // Quando o slider estiver em 20% os valores terao quer ser os originais
      cct: 15, //Valor temporario para o caso do cadeado
      Txmin: 0, //No caso de Txmin tem que calcular o termo Po - Cro e verificar se  Po - Cro >= Pmin
      Txmax: 15, //Valor minimo e maximo da taxa em relacao ao slider
      Ccmax: 41, //Comissao do corretor maxima
      Ccmin: 1, // Percentual de comissão do correto minimo
      Crmax: 0, // Comissão máxima
      Crmin: 0, // Comissão minima
    };
  },
  computed: {
    documentOrDefault() {
      return this.proposta || defaultDocument;
    },
    /* Fator que e combinacao de acc e atx */
    A() {
      return FATOR_COMBINACAO;
    },
    /* Comissão corretor ou percentual de commissão */
    Cco() {
      return this.documentOrDefault.comissao_percentual_passo5;
    },
    /* Comissão em reais */
    Cro() {
      return this.documentOrDefault.comissao_reais_passo5;
    },
    /* Taxa original */
    Txo() {
      return this.documentOrDefault.taxa_passo5;
    },
    /* Premio original */
    Po() {
      return this.documentOrDefault.premio_passo5;
    },
    /* Premio minimo aceito pela i4pro */
    Pmin() {
      return this.documentOrDefault.premio_minimo_passo5;
    }
  },
  methods: {
    /*
     * Calculando o valor de Crmax.
     */
    calcularComissaoMaxima() {
      const a = this.Txmax * this.Cco +
            this.A * this.Txmax ** 2 -
            this.A * this.Txmax * this.Txo;
      const b = this.Txo * this.Cco;
      return (a * this.Cro) / b;
    },

    calcularComissaoMaximaLabel(isClosed) {
      const value = isClosed ? this.cct : this.Ccmax;
      return (this.calcularPremio(this.Txmax) * value) / 100;
    },

    /*
     * Calculando o valor de Crmin.
     */
    calcularComissaoMinima() {
      if (this.Po - this.Cro < this.Pmin) {
        return this.Cro - (this.Po - this.Pmin);
      } else {
        return 0;
      }
    },

    /*
     * Calculando o valor de Crmin.
     */
    calcularComissaoMinimaLabel() {
      if (this.Crmin == 0) {
        return (this.calcularPremio(this.Txmin) * this.Ccmin) / 100;
      } else {
        return this.Crmin;
      }
    },

    /*
     * Calculate Txmin.
     * verificar se  Po - Cro < Pmin
     */
    calcularTaxaMinima() {
      if (this.Po - this.Cro < this.Pmin) {
        return (this.Pmin / this.Po) * this.Txo;
      } else {
        return ((this.Po - this.Cro) / this.Po) * this.Txo;
      }
    },

    /*
     * Metodo que calcula o premio
     */
    calcularPremio(taxa) {
      return (taxa / this.Txo) * this.Po;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/CalcMixin.js